import { render, staticRenderFns } from "./PersonalFilter.vue?vue&type=template&id=632b60b8&"
import script from "./PersonalFilter.vue?vue&type=script&lang=js&"
export * from "./PersonalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports